import React from 'react';
import styled from '@emotion/styled';

export interface MainColumnPreviewprops {
  backgroundUrl?: string;
  centered: boolean;
  children: React.ReactNode;
}
const Wrapper = styled.div<MainColumnPreviewprops>`
  flex: 1;
  overflow-y: auto;
  ${(props) => {
    if (props.backgroundUrl) {
      return `
        background-image: url(${props.backgroundUrl});
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
      `;
    }
  }}

  ${(props) => {
    if (props.centered) {
      return `
        display: flex;
        align-items: center;
        justify-content: center;
      `;
    }
  }}
`;

const MainColumnPreview = ({ children, ...props }: MainColumnPreviewprops) => {
  return <Wrapper {...props}>{children}</Wrapper>;
};

export default MainColumnPreview;
